import styled from "@emotion/styled";

/**
 * To be used to wrap a DefaultContainer. Has padding.
 */
export const DefaultWrapper = styled.div`
  padding: 0 52px;
`;
